import Vue from "vue";
import request from "./config/http.js";
import params from "./config/params.js";

let dev = "/tsg-admin";
let dev1 = "/txpy-web";
// 超管学科管理/学科列表
let url5 = "/tsg-admin/sys/subject";
// 运营管理员学科管理/学科列表
let url6 = "/tsg-admin/sys/perSubject";

const apis = {
  /*公共*/
  login(data) {
    //登录
    return request({
      url: dev + "/sys/login",
      method: "post",
      isToken: true,
      //       jsonString:true,
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  selPerList(data) {
    //普通用户期刊列表
    return request({
      url: dev + "/sys/selPerList",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  menuList(data) {
    //菜单权限列表
    return request({
      url: dev + "/sys/permissionList",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  haveMsg(data) {
    //菜单权限列表
    return request({
      url: dev + "/sys/systemMsg/haveMsg",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  updPwd(data) {
    //管理员修改密码
    return request({
      url: dev + "/sys/updPwd",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  logout(data) {
    //退出
    return request({
      url: dev + "/sys/logout",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  resetPwd(data) {
    //忘记密码
    return request({
      url: dev + "/sys/resetPwd",
      method: "post",
      data: data,
      isToken: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  sendCode(data) {
    //发送验证码
    return request({
      url: dev + "/sys/common/sendCode",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  findProvinceList(data) {
    //省
    return request({
      url: dev + "/sys/common/findProvinceList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  findAreaList(data) {
    //市
    return request({
      url: dev + "/sys/common/findAreaList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  userResetPwd(data) {
    //重置密码
    return request({
      url: dev + "/sys/user/resetPwd",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  /*集团管理*/
  periodicalPressList(data) {
    //列表
    return request({
      url: dev + "/sys/PeriodicalPress/list",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryMerchantList(data) {
    //收款商户列表
    return request({
      url: dev + "/sys/merchant/queryMerchant",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //修改期刊分账信息
  updatePeriodical(data) {
    return request({
      url: dev + "/sys/PeriodicalPress/updatePeriodical",
      method: "put",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //根据集团id查集团下的期刊
  getPressInfoList(data) {
    return request({
      url: dev + "/sys/PeriodicalPress/getPressInfoList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  selPerLists(data) {
    //普通用户选项
    return request({
      url: dev + "/sys/periodical/perList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  save(type, data) {
    //添加集团
    // 新增用户昵称和手机号使用查询字符串传输
    let paramStr = `?userName=${data.userName}&phone=${data.phone}`;
    return request({
      url:
        type == 1
          ? dev + "/sys/PeriodicalPress/save" + paramStr
          : dev + "/sys/PeriodicalPress/update" + paramStr,
      method: type == 1 ? "post" : "put",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  getPressInfo(data) {
    //集团详情
    return request({
      url: dev + "/sys/PeriodicalPress/getPressInfo",
      method: "get",
      params: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  periodicalPressUpdate(data) {
    //集团修改
    return request({
      url: dev + "/sys/PeriodicalPress/update",
      method: "put",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  periodicalPressDisable(data) {
    //集团禁用、启用
    return request({
      url: dev + "/sys/PeriodicalPress/disable",
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  /*期刊审核*/
  queryPeriodicalAuditList(data) {
    //列表
    return request({
      url: dev + "/sys/periodical/queryPeriodicalAuditList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*期刊统计*/
  queryGetEmailList(data) {
    //列表
    return request({
      url: dev + "/sys/statistics/getEmail",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryPeriodicalAuditInfo(data) {
    //查看资料（详情）
    return request({
      url: dev + "/sys/periodical/queryPeriodicalAuditInfo",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  auditPeriodicalInfo(data) {
    //查看资料（审核）
    return request({
      url: dev + "/sys/periodical/auditPeriodicalInfo",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  /*收款商户*/
  queryMerchant(data) {
    //列表
    return request({
      url: dev + "/sys/merchant/queryMerchant",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  getMerchantInfo(data) {
    //商户详情
    return request({
      url: dev + "/sys/merchant/getMerchantInfo",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  addMerchant(data) {
    //添加商户
    return request({
      url: dev + "/sys/merchant/addMerchant",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  editMerchant(data) {
    //修改商户信息
    return request({
      url: dev + "/sys/merchant/editMerchant",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  delMerchant(data) {
    //修改商户
    return request({
      url: dev + "/sys/merchant/delMerchant",
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  /*用户反馈*/
  feedbackList(data) {
    //列表
    return request({
      url: dev + "/sys/feedback/feedbackList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryFeedbackInfo(data) {
    //详情
    return request({
      url: dev + "/sys/feedback/queryFeedbackInfo",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  deleteFeedbackInfo(data) {
    //删除意见反馈
    return request({
      url: dev + "/sys/feedback/deleteFeedbackInfo",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*学科管理*/

  //一级学科列表
  findOneList(url,params) {
    return request({
      url: url + "/findOneList",
      method: "get",
      params
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  //二级学科列表
  findTwoList(url,params) {
    return request({
      url: url + "/findTwoList",
      method: "get",
      params
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  open(url,data) {
    // 状态开关
    return request({
      url: url + "/open",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  updateSubject(url,data) {
    // 修改学科
    return request({
      url: url + "/updateSubject",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  addSubject(url,data) {
    //增加学科
    return request({
      url: url + "/addSubject",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  delSubject(url,params) {
    //增加学科
    return request({
      url: url + "/del",
      method: "get",
      params
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  /*稿件查重*/
  queryCheckAuditList(data) {
    //查重列表
    return request({
      url: dev + "/sys/check/queryCheckAuditList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*自带查重列表*/
  byoPage(data) {
    //自带查重列表
    return request({
      url: dev + "/sys/check/byoPage",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*查重审核详情不通过选项列表*/
  notPassList(data) {
    //查重审核详情不通过选项列表
    return request({
      url: dev + "/sys/check/notPassList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*查重审核*/
  checkAudit(data) {
    //查重审核
    return request({
      url: dev + "/sys/check/audit",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*查重审核详情*/
  auditDetail(data) {
    //查重审核详情
    return request({
      url: dev + "/sys/check/auditDetail",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*查重记录*/
  queryCheckList(data) {
    //查重记录
    return request({
      url: dev + "/sys/check/queryCheckList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*查重记录New*/
  queryCheckListNew(data) {
    //查重记录New
    return request({
      url: dev + "/sys/check/queryCheckListNew",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*待查重列表*/
  pendingCCPage(data) {
    //待查重列表
    return request({
      url: dev + "/sys/check/pendingCCPage",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*待处理列表*/
  pendingPage(data) {
    //待处理列表
    return request({
      url: dev + "/sys/check/pendingPage",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  pendingIgnore(data) {
    //单个/批量忽略
    return request({
      url: dev + "/sys/check/pendingIgnore",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  batchCheckAudit(data) {
    //批量查重
    return request({
      url: dev + "/sys/check/batchCheckAudit",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  addCheckAuditRecording(data) {
    //稿件查重
    return request({
      url: dev + "/sys/check/addCheckAuditRecording",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  /*稿件复审*/
  queryReauditList(data) {
    //待复审列表
    return request({
      url: dev + "/sys/reaudit/queryReauditList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryReauditListForFinish(data) {
    //复审完成列表
    return request({
      url: dev + "/sys/reaudit/queryReauditListForFinish",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryReviewResult(data) {
    //查看初审意见
    return request({
      url: dev + "/sys/reaudit/queryReviewResult",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryReviewTemplate(data) {
    //查看初审意见
    return request({
      url: dev + "/sys/reviewTemplate/queryReviewTemplate",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  applyExpert(data) {
    //申请外审专家
    return request({
      url: dev + "/sys/reaudit/applyExpert",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryExpertAuditByAuditId(data) {
    //查看外审意见
    return request({
      url: dev + "/sys/expertAudit/queryExpertAuditByAuditId",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  reviewReaudit(data) {
    //提交复审意见
    return request({
      url: dev + "/sys/reaudit/reaudit",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryColumnListForSelect(data) {
    //复审拟发栏目
    return request({
      url: dev + "/sys/column/queryColumnListForSelect",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryReauditResult(data) {
    //查看复审意见
    return request({
      url: dev + "/sys/reaudit/queryReauditResult",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  /*审核模板*/
  addTemplate(data) {
    //添加
    return request({
      url: dev + "/sys/reviewTemplate/addReviewTemplate",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  templateList(data) {
    //列表
    return request({
      url: dev + "/sys/reviewTemplate/queryReviewTemplate",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  delReviewTemplate(data) {
    //删除
    return request({
      url: dev + "/sys/reviewTemplate/delReviewTemplate",
      method: "put",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  reviewTemplateDetail(data) {
    //模板查看
    return request({
      url: dev + "/sys/reviewTemplate/reviewTemplateDetail",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  /*稿件终审*/
  queryFinalAuditList(data) {
    //待终审列表
    return request({
      url: dev + "/sys/finalAudit/queryFinalAuditList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*稿件终审判断*/
  getFundAuditStatus(data) {
    //待终审列表
    return request({
      url: dev + "/sys/finalAudit/getFundAuditStatus",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryFinalAuditListForFinish(data) {
    //终审完成列表
    return request({
      url: dev + "/sys/finalAudit/queryFinalAuditListForFinish",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  finalAuditReaudit(data) {
    //提交终审意见
    return request({
      url: dev + "/sys/finalAudit/reaudit",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryFinalResult(data) {
    //终审意见查看
    return request({
      url: dev + "/sys/finalAudit/queryFinalResult",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryFinalAuditsList(data) {
    //稿件终审复审完成列表
    return request({
      url: dev + "/sys/finalAudit/queryFinalAuditsList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*录用确认*/
  queryArticleEmployList(data) {
    //列表
    return request({
      url: dev + "/sys/articleEmploy/queryArticleEmployList",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryArticleEmploySureInfo(data) {
    //录用确认信息
    return request({
      url: dev + "/sys/articleEmploy/queryArticleEmploySureInfo",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryEmploymentAmount(data) {
    //录用费追加
    return request({
      url: dev + "/sys/articleEmploy/queryEmploymentAmount",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  getLyDiscountList(data) {
    //录用费优惠
    return request({
      url: dev + "/sys/articleEmploy/getLyDiscountList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  updateEmploySureStatusById(data) {
    //利用确认提交
    return request({
      url: dev + "/sys/articleEmploy/updateEmploySureStatusById",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  updateAuditatusById(data) {
    //录用确认退修
    return request({
      url: dev + "/sys/articleEmploy/updateAuditatusById",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  /*稿件排期*/
  queryArticleSchedulingList(data) {
    //列表
    return request({
      url: dev + "/sys/periodArticleScheduling/queryArticleSchedulingList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  periodList(data) {
    //刊期列表
    return request({
      url: dev + "/sys/periodArticleScheduling/periodList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryArticleArchivingPeriodList(data) {
    //有数据刊期列表
    return request({
      url: dev + "/sys/archiving/queryArticleArchivingPeriodList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  batchCheckArticle(data) {
    //刊期列表
    return request({
      url: dev + "/sys/archiving/batchCheckArticle",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  archivingPeriodList(data) {
    //过刊录入刊期列表
    return request({
      url: dev + "/sys/archiving/periodList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  updateArticle(data) {
    //终版存档已完成-修改
    return request({
      url: dev + "/sys/archiving/updateArticle",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  deleteArticle(data) {
    //终版存档已完成-删除
    return request({
      url: dev + "/sys/archiving/deleteArticle",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  batchRecord(data) {
    //批量记录-
    return request({
      url: dev + "/sys/archiving/batchRecord",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  batchRecordPeriodList(data) {
    //批量记录刊期下拉
    return request({
      url: dev + "/sys/archiving/batchRecordPeriodList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  recordDetail(data) {
    //批量记录失败详情
    return request({
      url: dev + "/sys/archiving/recordDetail",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryColumnListForSelect(data) {
    //栏目列表
    return request({
      url: dev + "/sys/column/queryColumnListForSelect",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  batchScheduling(data) {
    //批量排期
    return request({
      url: dev + "/sys/periodArticleScheduling/batchScheduling",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  confirmScheduling(data) {
    //确认刊期
    return request({
      url: dev + "/sys/periodArticleScheduling/confirmScheduling",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  oneClickScheduling(data) {
    //一键排期
    return request({
      url: dev + "/sys/periodArticleScheduling/oneClickScheduling",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  updatePerod(data) {
    //修改刊期
    return request({
      url: dev + "/sys/periodArticleScheduling/updatePerod",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  /*校对*/
  queryPerformanceList(data) {
    //排版校对列表
    return request({
      url: dev + "/sys/proofread/queryPerformanceList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryProofreadList(data) {
    //绩效查询列表(旧)
    return request({
      url: dev + "/sys/proofread/queryProofreadList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryEditorial(data) {
    //编辑列表
    return request({
      url: dev + "/sys/proofread/queryEditorial",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /* v3.0.0 填写校对表单相关 */
  // 0. /sys/proofread/imporCheck 上传校对表单
  uploadProofFile(data) { 
    return request({
      url: dev + "/sys/proofread/imporCheck",
      method: "post",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
      dataType: "formData"
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 1. /sys/proofread/queryProofreadTempList  查询校对表单填写记录
  queryProofreadTempList(data) {
    
    return request({
      url: dev + "/sys/proofread/queryProofreadTempList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 2. /sys/proofread/saveProofread 保存校对表单填写
  saveProofread(data) {
    return request({
      url: dev + "/sys/proofread/saveProofread",
      method: "post",
      data: data,
      jsonString: true
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 3./sys/proofread/saveProofreadSubmit 提交校对表单填写
  saveProofreadSubmit(data) {
    
    return request({
      url: dev + "/sys/proofread/saveProofreadSubmit",
      method: "post",
      data: data,
      jsonString: true
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // 4. /sys/proofread/queryProofreadCompletedList 查询校对已完成列表
  queryProofreadCompletedList(data) {
    return request({
      url: dev + "/sys/proofread/queryProofreadCompletedList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 5. 校对已完成页面，查询当前期刊下与完成校对的年份列表
  queryProofFinishedYear(data) { 
    return request({
      url: dev + "/api/queryYearList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // 6. /sys/proofread/queryDetailList 已完成页面-查询刊期校对详情
  queryDetailList(data) { 
    return request({
      url: dev + "/sys/proofread/queryDetailList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

 


  /*外审分配*/
  queryExpertAllotList(data) {
    //列表
    return request({
      url: dev + "/sys/expertAllot/queryExpertAllotList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*外审分配列表*/
  auditPageList(data) {
    //列表
    return request({
      url: dev + "/sys/expertAudit/auditPage",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*外审分配查看审核状态*/
  getAuditList(data) {
    return request({
      url: dev + "/sys/expertAudit/getAuditList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*外审分配列表-查看审核记录*/
  getAuditDetail(data) {
    return request({
      url: dev + "/sys/expertAudit/getAuditDetail",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*取消外审*/
  cancelAudit(data) {
    return request({
      url: dev + "/sys/expertAudit/cancelAudit",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryAllotExpertInfo(data) {
    //专家回显
    return request({
      url: dev + "/sys/expertAllot/queryAllotExpertInfo",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  queryExpertList(data) {
    //专家列表（下拉）
    return request({
      url: dev + "/sys/expertAllot/queryExpertList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  pageExpertList(data) {
    //专家列表（弹框）
    return request({
      url: dev + "/sys/expertAllot/pageExpertList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  allotExpert(data) {
    //分配外审专家
    return request({
      url: dev + "/sys/expertAllot/allotExpert",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  cancelDistribution(data) {
    //撤销分配
    return request({
      url: dev + "/sys/expertAllot/cancelDistribution",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  /*终版存档*/
  queryArticleArchivingList(data) {
    //列表
    return request({
      url: dev + "/sys/archiving/queryArticleArchivingList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  checkArticle(data, vm2) {
    //保存

    if (vm2.canCheckArtical) {
      // 按钮是否可点击-状态标识
      vm2.canCheckArtical = false;
      return request({
        url: dev + "/sys/archiving/checkArticle",
        method: "post",
        data: data,
        jsonString: true,
      }).then((result) => {
        vm2.canCheckArtical = true;
        return Promise.resolve(result.data);
      });
    }
  },
  queryArticleInfoById(data) {
    //回显详情
    return request({
      url: dev + "/sys/archiving/queryArticleInfoById",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  findAuthorByPhoneAndName(data) {
    //添加作者
    return request({
      url: dev + "/sys/archiving/findAuthorByPhoneAndName",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //通过手机号查询作者
  findAuthorByPhone(data) {
    //添加作者
    return request({
      url: dev + "/sys/archiving/findAuthorByPhone",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  registerAuthor(data) {
    //添加作者信息
    return request({
      url: dev + "/sys/archiving/registerAuthor",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  findAuthorByAuthorId(data) {
    //根据id查询作者信息
    return request({
      url: dev + "/sys/archiving/findAuthorByAuthorId",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  addFeedback(data) {
    //意见反馈
    return request({
      url: dev + "/sys/feedback/addFeedback",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  /*消息通知*/
  queryMessageList(data) {
    //列表
    return request({
      url: dev + "/sys/message/queryMessageList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*消息列表*/
  systemMsgPage(data) {
    //列表
    return request({
      url: dev + "/sys/systemMsg/page",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*作者消息列表*/
  tsgChatList(data) {
    //列表
    return request({
      url: dev + "/sys/tsgChat/list",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*消息类型下拉*/
  systemMsgTypeList(data) {
    //列表
    return request({
      url: dev + "/sys/systemMsg/typeList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*删除消息*/
  systemMsgDel(data) {
    //列表
    return request({
      url: dev + "/sys/systemMsg/del",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /*查看消息详情*/
  systemMsgDetail(data) {
    //列表
    return request({
      url: dev + "/sys/systemMsg/detail",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  deleteMessageList(data) {
    //删除
    return request({
      url: dev + "/sys/message/deleteMessageList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  readMessage(data) {
    //读
    return request({
      url: dev + "/sys/message/readMessage",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  /*个人信息*/
  userDetail(data) {
    //个人信息详情
    return request({
      url: dev + "/sys/user/detail",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  updDetail(data) {
    //修改个人详情
    return request({
      url: dev + "/sys/user/updDetail",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //用户日志
  webUserList(data) {
    //个人信息详情
    return request({
      url: dev + "/sys/journal/userList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //稿件下载
  downloadArticle(data, type) {
    let urlDown = "";
    if (type == 3) {
      urlDown = "/sys/download/downloadAgreement"; //后台版权协议下载
    } else if (type == 2) {
      urlDown = "/sys/download/downloadAnnex"; //后台附件下载
    } else {
      urlDown = "/sys/download/downloadArticle"; //稿件下载
    }
    return request({
      url: dev + urlDown,
      method: "get",
      params: data,
      isToken: false,
      requestType: "blob",
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //畅写强制保存接口
  checkFile(data) {
    return request({
      url: dev + "/api/checkFile",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //强制保存接口
  checkFileKey(data) {
    return request({
      url: dev + "/api/checkFileKey",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  //期刊管理列表
  queryList(data) {
    return request({
      url: dev + "/sys/periodical/queryList",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //状态设置
  updProhibited(data) {
    return request({
      url: dev + "/sys/periodical/updProhibited",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //机构--期刊管理列表（其他期刊）
  queryListOther(data) {
    return request({
      url: dev + "/sys/periodical/queryListOther",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //新建期刊
  periodicalAdd(data) {
    return request({
      url: dev + "/sys/periodical/add",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //机构--其他期刊配置机构
  addPerPressId(data) {
    return request({
      url: dev + "/sys/periodical/addPerPressId",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //修改期刊
  periodicalUpdate(data) {
    return request({
      url: dev + "/sys/periodical/update",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //期刊启用禁用
  updateContribute(data) {
    return request({
      url: dev + "/sys/periodical/updateContribute",
      method: "post",
      data: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //强制保存接口
  queryArticlePath(data) {
    return request({
      url: dev + "/api/queryArticlePath",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //筛稿 —— 待筛稿列表
  screeningList(data) {
    return request({
      url: dev + "/sys/screening/list",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //提交审核意见信息
  addScreeningAudit(data) {
    return request({
      url: dev + "/sys/screening/addScreeningAudit",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  titleRecord(data) {
    //稿件标题对比
    return request({
      url: dev + "/sys/titleRecord/list",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //提交审核意见信息
  addScreeningAuditBatch(data) {
    return request({
      url: dev + "/sys/screening/addScreeningAuditBatch",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // v3.0.4 录用确认审核 时查询附件拦截状态
  annexInterceptStatus(params) { 
    return request({
      url: dev + "/sys/articleEmploy/annexIntercept",
      method: "get",
      params,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  }, 
  //单位级别列表-父级id，没有为一级列表，有为二级列表
  unitLevelList(params) {
    return request({
      url: dev + "/sys/unitLevel/list",
      method: "get",
      params
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //单位级别开关
  unitLevelSwitch(params) {
    return request({
      url: dev + "/sys/unitLevel/levelSwitch",
      method: "get",
      params
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //添加/修改单位级别
  unitLevelAdd(data) {
    return request({
      url: dev + "/sys/unitLevel/add",
      method: "post",
      jsonString: true,
      data
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //删除单位级别
  unitLevelDel(params) {
    return request({
      url: dev + "/sys/unitLevel/del",
      method: "get",
      params
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //设置单位级别列表
  unitLevelConfigList(params) {
    return request({
      url: dev + "/sys/unitLevel/configList",
      method: "get",
      params
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //投稿设置-保存单位级别
  addPerConfig(data) {
    return request({
      url: dev + "/sys/unitLevel/addPerConfig",
      method: "post",
      jsonString: true,
      data
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //投稿设置-已设置单位级别列表回显/后台的下拉列表也用这个
  existConfigList(params) {
    return request({
      url: dev + "/sys/unitLevel/existConfigList",
      method: "get",
      params
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 期刊审核-作者登录页-待审列表
  loginConfigAudit(params) {
    return request({
      url: dev + "/sys/periodicalLogin/queryPeriodicalLoginList",
      method: "get",
      params
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 期刊审核-作者登录页-已审核列表
  loginConfigReviewed(params) {
    return request({
      url: dev + "/sys/periodicalLogin/queryPeriodicalRecordingList",
      method: "get",
      params
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 期刊审核-作者登录页-配置详情
  loginConfigDetail (params) {
    return request({
      url: dev + "/sys/periodicalLogin/details",
      method: "get",
      params
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 期刊审核-作者登录页-审核详情
  loginAuditDetail (params) {
    return request({
      url: dev + "/sys/periodicalLogin/detailsAuditInfo",
      method: "get",
      params
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 期刊审核-作者登录页-审核
  periodicalLoginAudit (params) {
    return request({
      url: dev + "/sys/periodicalLogin/audit",
      method: "get",
      params
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 风险详情
  warningDetail(params) {
    return request({
      url: dev + "/admin/risk/warning/detail",
      method: "get",
      params
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 发送消息
  tsgChatSend(data) {
    return request({
      url: dev + "/sys/tsgChat/send",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 获取
  getHistory(data) {
    return request({
      url: dev + "/sys/tsgChat/getHistory",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 获取最新消息
  getNewMsg(data) {
    return request({
      url: dev + "/sys/tsgChat/getNewMsg",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 忽略
  ignore(data) {
    return request({
      url: dev + "/sys/tsgChat/ignore",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 科研诚信检测管理--批量设置AIGC数
  batchSetAigc(data) {
    return request({
      url: dev + "/sys/periodical/batchSetAigc",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 科研诚信检测管理--批量设置查重数
  batchSetCheck(data) {
    return request({
      url: dev + "/sys/periodical/batchSetCheck",
      method: "post",
      data: data,
      jsonString: true,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 科研诚信检测管理--批量设置AIGC详情
  batchSetAigcDetail(data) {
    return request({
      url: dev + "/sys/periodical/batchSetAigcDetail",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 科研诚信检测管理--批量设置查重详情
  batchSetCheckDetail(data) {
    return request({
      url: dev + "/sys/periodical/batchSetCheckDetail",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 科研诚信检测管理--AIGC配置列表
  perAigcList(data) {
    return request({
      url: dev + "/sys/periodical/perAigcList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 科研诚信检测管理--查重配置列表
  perCheckList(data) {
    return request({
      url: dev + "/sys/periodical/perCheckList",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // 科研诚信检测管理--单个设置查重数页详情
  perCheckSetDetail(data) {
    return request({
      url: dev + "/sys/periodical/perCheckSetDetail",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 科研诚信检测管理--单个设置查重数
  perCheckSet(data) {
    return request({
      url: dev + "/sys/periodical/perCheckSet",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 科研诚信检测管理--单个设置AIGC数页详情
  perAigcSetDetail(data) {
    return request({
      url: dev + "/sys/periodical/perAigcSetDetail",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 科研诚信检测管理--单个设置AIGC数
  perAigcSet(data) {
    return request({
      url: dev + "/sys/periodical/perAigcSet",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 站内查重检测（万方单篇检测）
  wanFangCheck(data) {
    return request({
      url: dev + "/sys/check/wanFangCheck",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 获取开关自动检测手动检测
  checkType(data) {
    return request({
      url: dev + "/sys/check/checkType",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 轮询
  selWanFangCheckInfo(data) {
    return request({
      url: dev + "/sys/check/selWanFangCheckInfo",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  //总篇数设置
  setAllCheckCount(data) {
    return request({
      url: dev + "/sys/periodical/setAllCheckCount",
      method: "get",
      params: data,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
};

export default apis;



// WEBPACK FOOTER //
// ./src/core/api/manage.serve.js